import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStatusError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	ffill: "currentcolor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z",
		clipRule: "evenodd"
	})
});
export default SvgStatusError;
